var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          "left-side-class": "col-xl-4 pb-2",
          page: _vm.headerConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _vm.queuedClaimsInfo
        ? _c("custom-error", {
            attrs: {
              "is-alert-mode": "",
              message: _vm.queueMessage(),
              variant: "mt-1"
            }
          })
        : _vm._e(),
      _vm.isclamimStartCardOpen
        ? _c("claim-start-card", {
            on: {
              cancel: _vm.onClose,
              confirm: _vm.onConfirm,
              "is-automatic": _vm.onAutomaticChanged
            },
            model: {
              value: _vm.isAutomatic,
              callback: function($$v) {
                _vm.isAutomatic = $$v
              },
              expression: "isAutomatic"
            }
          })
        : _vm._e(),
      _vm.isBatchMassSendOpen
        ? _c("batch-mass-send", {
            attrs: { batches: _vm.selectedBatches },
            on: {
              cancel: _vm.onBatchMassCancel,
              confirm: _vm.onBatchMassConfirm
            }
          })
        : _vm._e(),
      _c(
        "q-tab",
        {
          attrs: {
            "active-tab": _vm.currentIndexTab,
            "nav-class": "text-nowrap"
          }
        },
        [
          _c(
            "q-tab-item",
            {
              attrs: {
                active:
                  !_vm.currentIndexTab ||
                  _vm.currentIndexTab === _vm.tabs.Preelegibles,
                lazy: "",
                tabindex: _vm.tabs.Preelegibles,
                title: "Servicios Elegibles"
              },
              on: {
                click: function($event) {
                  return _vm.onActiveTab(_vm.tabs.Preelegibles)
                }
              }
            },
            [
              _c("filter-manager", {
                ref: "filterRef",
                staticClass: "mb-4",
                attrs: {
                  filters: _vm.filtersConfig,
                  "open-advanced": _vm.shoudDisplayAdvancedFilters
                },
                on: {
                  "update:openAdvanced": function($event) {
                    _vm.shoudDisplayAdvancedFilters = $event
                  },
                  "update:open-advanced": function($event) {
                    _vm.shoudDisplayAdvancedFilters = $event
                  },
                  search: function($event) {
                    return _vm.onSearchHandler()
                  }
                },
                model: {
                  value: _vm.filter.model,
                  callback: function($$v) {
                    _vm.$set(_vm.filter, "model", $$v)
                  },
                  expression: "filter.model"
                }
              }),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-end align-items-center mb-3 my-pill-theme"
                },
                [
                  _vm.showChecks
                    ? _c(
                        "div",
                        { staticClass: "mr-2" },
                        [
                          _c("check-box", {
                            staticClass:
                              "d-flex justify-content-end text-green",
                            attrs: {
                              "checked-bg-color": "bg-success",
                              icon: "fal fa-check",
                              text: _vm.allCheckedText
                            },
                            model: {
                              value: _vm.allChecked,
                              callback: function($$v) {
                                _vm.allChecked = $$v
                              },
                              expression: "allChecked"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("active-dropdown", {
                    attrs: {
                      "background-color": "#9FAEA7",
                      icon: "fas fa-chevron-down",
                      "label-key": "label",
                      options: _vm.serviceTypes,
                      "value-key": "id"
                    },
                    on: { input: _vm.onServiceTypeChanged },
                    model: {
                      value: _vm.serviceType,
                      callback: function($$v) {
                        _vm.serviceType = $$v
                      },
                      expression: "serviceType"
                    }
                  })
                ],
                1
              ),
              _c("custom-separator", {
                staticClass: "my-4",
                attrs: { text: "Resultados" }
              }),
              _vm.results.length == 0
                ? _c("custom-result-not-found", {
                    attrs: { text: "No hay información disponible." }
                  })
                : _vm._e(),
              _vm.results.length
                ? _c(
                    "div",
                    [
                      _vm.isByService
                        ? _vm._l(_vm.results, function(item) {
                            return _c("result-row", {
                              key: item.id,
                              staticClass: "my-3",
                              attrs: { checkable: _vm.showChecks, value: item }
                            })
                          })
                        : _vm._e(),
                      _vm.isByServiceLocation
                        ? _vm._l(_vm.results, function(item) {
                            return _c("service-location-result-row", {
                              key: item.location.id,
                              staticClass: "my-3",
                              attrs: { checkable: _vm.showChecks, value: item },
                              on: { "view-services": _vm.onViewServicesHandler }
                            })
                          })
                        : _vm._e(),
                      _vm.isByStudent
                        ? _vm._l(_vm.results, function(item) {
                            return _c("student-result-row", {
                              key: item.id,
                              staticClass: "my-3",
                              attrs: { value: item },
                              on: { "view-services": _vm.onViewServicesHandler }
                            })
                          })
                        : _vm._e(),
                      _vm.showPagination
                        ? _c("pagination", {
                            attrs: { data: _vm.pagination, "show-text": "" },
                            on: { "pagination-go-page": _vm.onSearchHandler }
                          })
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "q-tab-item",
            {
              attrs: {
                active: _vm.currentIndexTab === _vm.tabs.Reclamaciones,
                lazy: "",
                tabindex: _vm.tabs.Reclamaciones,
                title: "Reclamaciones"
              },
              on: {
                click: function($event) {
                  return _vm.onActiveTab(_vm.tabs.Reclamaciones)
                }
              }
            },
            [
              _c("filter-manager", {
                ref: "filterClaimRef",
                staticClass: "mb-4",
                attrs: { filters: _vm.filtersConfigBatch },
                on: {
                  search: function($event) {
                    return _vm.onBatchSearchHandler()
                  }
                },
                model: {
                  value: _vm.filter.model,
                  callback: function($$v) {
                    _vm.$set(_vm.filter, "model", $$v)
                  },
                  expression: "filter.model"
                }
              }),
              _c("custom-separator", {
                staticClass: "my-4",
                attrs: { text: "Resultados" }
              }),
              _vm.results.length == 0
                ? _c("custom-result-not-found", {
                    attrs: { text: "No hay información disponible." }
                  })
                : _vm._e(),
              _vm.showBatchChecks
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-end"
                    },
                    [
                      _c("check-box", {
                        staticClass: "d-flex justify-content-end text-green",
                        attrs: {
                          "checked-bg-color": "bg-success",
                          icon: "fal fa-check",
                          text: _vm.allCheckedText
                        },
                        model: {
                          value: _vm.allChecked,
                          callback: function($$v) {
                            _vm.allChecked = $$v
                          },
                          expression: "allChecked"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.results, function(item) {
                return _c("batch-result-row", {
                  key: item.id,
                  staticClass: "mt-3",
                  attrs: { checkable: _vm.showBatchChecks, value: item },
                  on: {
                    refresh: function($event) {
                      return _vm.onBatchSearchHandler()
                    }
                  }
                })
              }),
              _vm.showPagination
                ? _c("pagination", {
                    attrs: { data: _vm.pagination, "show-text": "" },
                    on: { "pagination-go-page": _vm.onBatchSearchHandler }
                  })
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }